module.exports = "button{border:none;background:none}button img{width:24px;height:24px;opacity:.6}button img:hover{opacity:1}"